var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconLinkedin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_linkedin")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn_Circle",
    "data-name": "LinkedIn Circle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,14a2,2,0,1,0,2,2A2,2,0,0,0,16,14ZM14,30h4V19H14ZM27.36,19c-3,0-3.36,1.78-3.36,1.78V19H20V30h4V24s0-2,1.7-2c1,0,1.3.89,1.3,2v6h4V24C31,20.87,29.64,19,27.36,19ZM22,0A22,22,0,1,0,44,22,22,22,0,0,0,22,0Zm0,42A20,20,0,1,1,42,22,20,20,0,0,1,22,42Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLinkedin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_linkedin.8bfb5541.svg";
export { ForwardRef as ReactComponent };